(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.bce = {
    attach: function (context, settings) {
      once('bce', '#edit-field-company-number-0-value', context).forEach(function (block) {
        $(block).wrap('<div class="bce">BE<div>')
        var patternMask = IMask(document.getElementById('edit-field-company-number-0-value'), {
          mask: '0000{.}000{.}000',
        });
      });
    }
  }
})(jQuery, Drupal, once, drupalSettings);
